const env_prod = {
    
}

export { env_prod }